import { useSearchBox } from "react-instantsearch";
import { m } from "#/paraglide/messages";

function SearchIcon() {
	return (
		<svg aria-hidden="true" className="icon icon-24">
			<use xlinkHref="/umbrella/ui/icon-sprite.svg#sprite-ic_fluent_search_24_regular" />
		</svg>
	);
}

export default function AlgoliaSearchBox() {
	const { query, refine } = useSearchBox();
	const placeholder = m.search_placeholder();

	return (
		<form className="m-0" onSubmit={(event) => event.preventDefault()}>
			<label className="sr-only" htmlFor="site-search">
				{m.search()}
			</label>
			<div className="search-inner">
				<input
					className="form-control form-control-search"
					id="site-search"
					onChange={(event) => refine(event.currentTarget.value)}
					placeholder={placeholder}
					type="search"
					value={query}
				/>
				<button className="btn btn-search px-3" type="submit">
					<SearchIcon />
					<span className="sr-only">{m.search()}</span>
				</button>
			</div>
		</form>
	);
}
